export const getStatusActiveByDeletedAt = (deletedAt) => {
	return deletedAt ? 'inactive' : 'active'
}
